import request from '../utils/request'

export function getlist(data) {
    return request({
        url: '/api/supplier/list',
        method: 'get',
        params: {
            ...data,
        },
    })
}

export function recommendList(data) {
    return request({
        url: '/api/supplier/recommendList',
        method: 'get',
        params: {
            ...data,
        },
    })
}

export function swiperList(data) {
    return request({
        url: '/api/article/pic',
        method: 'get',
        params: {
            ...data,
        },
    })
}
export function supplierDetail(data) {
    return request({
        url: '/api/supplier/details',
        method: 'get',
        params: {
            ...data,
        },
    })
}
export function cityList(data) {
    return request({
        url: '/api/supplier/city',
        method: 'get',
        params: {
            ...data,
        },
    })
}

// 最新资讯
export function News(data) {
    return request({
        url: '/api/article/news',
        method: 'get',
        params: {
            ...data,
        },
    })
}

// 行业动态
export function industryNew(data) {
    return request({
        url: '/api/article/industry',
        method: 'get',
        params: {
            ...data,
        },
    })
}